function ProgrammeDetailsModal({
  isOpen,
  selectedProgrammeDetail,
  isMobile,
  closeProgrammeDetails,
  hoveredButton,
  setHoveredButton,
  secondaryButtonStyle,
  chooseProgramme,
  appTheme,
  isActive,
}) {
  if (!isOpen || !selectedProgrammeDetail) return null;

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 1500,
      background: appTheme.pageBackground,
      display: "flex",
      flexDirection: "column",
      overflowY: "hidden",
      animation: "settingsSheetIn 0.28s cubic-bezier(0.22, 1, 0.36, 1)"
    }}>
      {/* Header */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "44px 1fr 44px",
        alignItems: "center",
        padding: isMobile ? "16px 16px 12px" : "20px 24px 14px",
        borderBottom: appTheme.cardBorder,
        background: appTheme.cardBackground,
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        flexShrink: 0,
        position: "sticky",
        top: 0,
        zIndex: 10
      }}>
        <button
          onClick={closeProgrammeDetails}
          style={{
            width: "36px", height: "36px", borderRadius: "999px",
            border: appTheme.pillBorder, background: appTheme.pillBackground,
            color: appTheme.primaryText, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "20px", lineHeight: 1
          }}
        >‹</button>

        <div style={{ textAlign: "center" }}>
          <div style={{
            fontSize: "16px", fontWeight: "700", color: appTheme.primaryText
          }}>
            Programme
          </div>
        </div>

        <div />
      </div>

      {/* Scrollable content */}
      <div className="modal-scroll-hidden" style={{
        flex: 1, overflowY: "auto",
        padding: isMobile ? "24px 18px 40px" : "30px 24px 40px"
      }}>
        {/* Hero section */}
        <div style={{
          padding: isMobile ? "24px 18px" : "30px 24px",
          borderRadius: "24px",
          background: appTheme.softBackground,
          border: appTheme.cardBorder,
          marginBottom: "20px"
        }}>
          <div style={{
            fontSize: "12px", fontWeight: "700",
            letterSpacing: "0.08em", textTransform: "uppercase",
            color: appTheme.secondaryText, marginBottom: "8px"
          }}>
            Programme
          </div>

          <h2 style={{
            margin: 0,
            fontSize: isMobile ? "28px" : "34px",
            fontWeight: "700",
            fontFamily: appTheme.fontHeading,
            color: appTheme.primaryText,
            lineHeight: 1.08,
            marginBottom: "14px"
          }}>
            {selectedProgrammeDetail.name}
          </h2>

          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {(selectedProgrammeDetail.tags || []).map((tag, i) => (
              <span key={i} style={{
                padding: "7px 12px", borderRadius: "999px",
                background: appTheme.accentLight, color: appTheme.accentColor,
                fontSize: "13px", fontWeight: "700"
              }}>
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* Description */}
        <div style={{
          fontSize: "15px", color: appTheme.secondaryText,
          lineHeight: 1.7, marginBottom: "20px"
        }}>
          {selectedProgrammeDetail.description}
        </div>

        {/* What to expect */}
        <div style={{
          padding: "16px", borderRadius: "18px",
          background: appTheme.cardBackground, border: appTheme.cardBorder,
          marginBottom: "12px"
        }}>
          <div style={{
            fontSize: "13px", fontWeight: "700",
            letterSpacing: "0.08em", textTransform: "uppercase",
            color: appTheme.secondaryText, marginBottom: "8px"
          }}>
            What to expect
          </div>
          <div style={{ display: "grid", gap: "8px", fontSize: "14px", color: appTheme.primaryText, lineHeight: 1.6 }}>
            <div>• Structured weekly meal guidance</div>
            <div>• Simple recipe-led planning</div>
            <div>• Flexible meal editing if you want to personalise it</div>
          </div>
        </div>

        {/* Best for */}
        <div style={{
          padding: "16px", borderRadius: "18px",
          background: appTheme.cardBackground, border: appTheme.cardBorder,
          marginBottom: "28px"
        }}>
          <div style={{
            fontSize: "13px", fontWeight: "700",
            letterSpacing: "0.08em", textTransform: "uppercase",
            color: appTheme.secondaryText, marginBottom: "8px"
          }}>
            Best for
          </div>
          <div style={{ fontSize: "14px", color: appTheme.primaryText, lineHeight: 1.6 }}>
            People who want more structure in their planning without losing the flexibility to swap meals when needed.
          </div>
        </div>

        {/* Buttons */}
        {!isActive && (
          <button
            onMouseEnter={() => setHoveredButton("programme-detail-choose")}
            onMouseLeave={() => setHoveredButton(null)}
            onClick={() => {
              chooseProgramme(selectedProgrammeDetail);
              closeProgrammeDetails();
            }}
            style={{
              width: "100%",
              minHeight: isMobile ? "50px" : "46px",
              borderRadius: "16px",
              border: "none",
              background: appTheme.accentColor,
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "15px",
              cursor: "pointer",
              transition: "all 0.18s ease",
              transform: hoveredButton === "programme-detail-choose" ? "translateY(-1px)" : "translateY(0)"
            }}
          >
            Choose Programme
          </button>
        )}
      </div>
    </div>
  );
}

export default ProgrammeDetailsModal;